import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsMobileMenuOpen(false);
  };
  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200" data-id="element-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-101">
        <div className="flex items-center justify-between h-20" data-id="element-102">
          {/* Logo - now interactive */}
          <a href="/" onClick={scrollToTop} className="flex items-center gap-3 cursor-pointer group" data-id="element-103">
            <div className="w-8 h-8 relative transition-transform group-hover:scale-110 duration-200" data-id="element-104">
              <div className="absolute inset-0 bg-gradient-to-br from-[#0F52BA] to-[#06B6D4] rounded-full" data-id="element-105"></div>
              <div className="absolute inset-[3px] bg-white rounded-full" data-id="element-106"></div>
              <div className="absolute inset-[6px] bg-gradient-to-br from-[#0F52BA] to-[#06B6D4] rounded-full" data-id="element-107"></div>
            </div>
            <span className="text-2xl font-bold tracking-tight text-[#0A1628] group-hover:text-[#0F52BA] transition-colors duration-200" data-id="element-108">
              Think Act
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-109">
            <a href="#services" className="text-sm font-medium text-gray-700 hover:text-[#0F52BA] transition-colors" data-id="element-110">
              Services
            </a>
            <a href="#results" className="text-sm font-medium text-gray-700 hover:text-[#0F52BA] transition-colors" data-id="element-111">
              Results
            </a>
            <a href="#about" className="text-sm font-medium text-gray-700 hover:text-[#0F52BA] transition-colors" data-id="element-112">
              About Us
            </a>
            <a href="#contact" className="text-sm font-medium text-gray-700 hover:text-[#0F52BA] transition-colors" data-id="element-113">
              Contact
            </a>
          </nav>

          {/* Desktop CTA */}
          <a href="#contact" className="hidden md:block px-6 py-2.5 bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] text-white text-sm font-semibold rounded-full hover:shadow-lg hover:scale-105 transition-all duration-200" data-id="element-114">
            Get in Touch
          </a>

          {/* Mobile menu button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-gray-700 hover:text-[#0F52BA] transition-colors" aria-label="Toggle menu" data-id="element-115">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-116" /> : <Menu className="w-6 h-6" data-id="element-117" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <AnimatePresence data-id="element-118">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="md:hidden bg-white/95 backdrop-blur-md border-b border-gray-200 overflow-hidden" data-id="element-119">
            <nav className="px-6 py-6 space-y-4" data-id="element-120">
              <a href="#services" onClick={handleNavClick} className="block text-base font-medium text-gray-700 hover:text-[#0F52BA] transition-colors py-2" data-id="element-121">
                Services
              </a>
              <a href="#results" onClick={handleNavClick} className="block text-base font-medium text-gray-700 hover:text-[#0F52BA] transition-colors py-2" data-id="element-122">
                Results
              </a>
              <a href="#about" onClick={handleNavClick} className="block text-base font-medium text-gray-700 hover:text-[#0F52BA] transition-colors py-2" data-id="element-123">
                About Us
              </a>
              <a href="#contact" onClick={handleNavClick} className="block text-base font-medium text-gray-700 hover:text-[#0F52BA] transition-colors py-2" data-id="element-124">
                Contact
              </a>
              <a href="#contact" onClick={handleNavClick} className="block w-full px-6 py-3 bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] text-white text-base font-semibold rounded-full hover:shadow-lg transition-all duration-200 text-center mt-4" data-id="element-125">
                Get in Touch
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}